// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__a9D8M","amount":"Amount_amount__1TEei","tip":"Amount_tip__X-jUJ","tipHeader":"Amount_tipHeader__3PVyt","tipsWrap":"Amount_tipsWrap__2c41M"};